const fields = [
  {
    key: 'licensePlate',
    label: 'report.fields.licensePlate',
    header: 'licensePlate',
    filter: true,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'hullNo',
    label: 'report.fields.hullNo',
    header: 'hullNo',
    filter: true,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'driver',
    label: 'report.fields.driver',
    header: 'driver',
    filter: true,
    width: 20,
    headerRowspan: 2,
  },
  {
    key: 'vehicleType',
    label: 'report.fields.vehicleType',
    header: 'vehicleType',
    filter: false,
    width: 30,
    headerRowspan: 2,
  },
  {
    key: 'loadingGeofence',
    label: 'report.fields.loadingGeofence',
    header: 'loadingGeofence',
    filter: false,
    width: 30,
    headerRowspan: 2,
  },
  {
    key: 'dumpingGeofence',
    label: 'report.fields.dumpingGeofence',
    header: 'dumpingGeofence',
    filter: false,
    width: 30,
    headerRowspan: 2,
  },
  {
    key: 'ritageTime',
    label: 'report.fields.ritageTime',
    filter: false,
    isLocked: true,
    width: 30,
    children: [
      {
        key: 'startTime',
        label: 'report.fields.startTime',
        header: 'startTime',
        filter: false,
        isLocked: true,
        width: 20,
        childOfIndex: 0,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'finishTime',
        label: 'report.fields.finishTime',
        header: 'finishTime',
        filter: false,
        isLocked: true,
        width: 30,
        childOfIndex: 0,
        isTopHead: 0,
        headerColspan: 1,
      },
      {
        key: 'totalDuration',
        label: 'report.fields.totalTime',
        header: 'totalDuration',
        filter: false,
        isLocked: true,
        width: 30,
        childOfIndex: 0,
        isTopHead: 0,
        headerColspan: 1,
        tdAttr: (value, key, item, index) => {
          if (item.durationFilter.includes('totalRitageDuration')) {
            return { style: 'background-color: #FFF9E6;' }
          }
        },
      },
      {
        key: 'totalHours',
        label: 'report.fields.totalHours',
        header: 'totalMovingHours',
        filter: false,
        isLocked: true,
        width: 30,
        childOfIndex: 0,
        isTopHead: 0,
        headerColspan: 1,
      },
      {
        key: 'totalHourStop',
        label: 'report.fields.totalHourStop',
        header: 'totalHourTripStop',
        filter: false,
        isLocked: true,
        width: 30,
        childOfIndex: 0,
        isTopHead: 0,
        headerColspan: 1,
      },
    ],
    headerColspan: 5,
  },
  {
    key: 'odometer',
    label: 'report.fields.odometer',
    filter: false,
    isLocked: true,
    width: 30,
    children: [
      {
        key: 'startOdometer',
        label: 'report.fields.start',
        header: 'startOdometer',
        filter: false,
        isLocked: true,
        width: 20,
        childOfIndex: 1,
        isTopHead: 1,
        headerColspan: 1,
      },
      {
        key: 'endOdometer',
        label: 'report.fields.end',
        header: 'endOdometer',
        filter: false,
        isLocked: true,
        width: 30,
        childOfIndex: 1,
        isTopHead: 0,
        headerColspan: 1,
      },
    ],
    headerColspan: 2,
  },
  {
    key: 'tripMileage',
    label: 'report.fields.totalDistance',
    header: 'tripMileage',
    filter: false,
    width: 10,
    headerRowspan: 2,
  },
  {
    key: 'passedSegment',
    label: 'report.fields.passedSegment',
    header: 'passedSegment',
    filter: false,
    width: 10,
    headerRowspan: 2,
  },
  {
    key: 'loadingCondition',
    label: 'report.fields.loadingCondition',
    filter: false,
    isLocked: true,
    width: 30,
    children: [
      {
        key: 'travelDurationLoaded',
        label: 'report.fields.travelDuration',
        header: 'travelDurationLoaded',
        filter: false,
        isLocked: true,
        width: 20,
        childOfIndex: 2,
        isTopHead: 1,
        headerColspan: 1,
        tdAttr: (value, key, item, index) => {
          if (item.durationFilter.includes('loadedTravelDuration')) {
            return { style: 'background-color: #FFF9E6;' }
          }
        },
      },
      {
        key: 'stoppedDurationLoaded',
        label: 'report.fields.stoppedDuration',
        header: 'stoppedDurationLoaded',
        filter: false,
        isLocked: true,
        width: 20,
        childOfIndex: 2,
        isTopHead: 0,
        headerColspan: 1,
        tdAttr: (value, key, item, index) => {
          if (item.durationFilter.includes('stoppedDurationLoaded')) {
            return { style: 'background-color: #FFF9E6;' }
          }
        },
      },
      {
        key: 'averageSpeedLoaded',
        label: 'report.fields.averageSpeed',
        header: 'averageSpeedLoaded',
        filter: false,
        isLocked: true,
        width: 30,
        childOfIndex: 2,
        isTopHead: 0,
        headerColspan: 1,
      },
      {
        key: 'loadedDuration',
        label: 'report.fields.loadingDuration',
        header: 'loadedDuration',
        filter: false,
        isLocked: true,
        width: 30,
        childOfIndex: 2,
        isTopHead: 0,
        headerColspan: 1,
        tdAttr: (value, key, item, index) => {
          if (item.durationFilter.includes('loadingDuration')) {
            return { style: 'background-color: #FFF9E6;' }
          }
        },
      },
    ],
    headerColspan: 4,
  },
  {
    key: 'unloadingCondition',
    label: 'report.fields.unloadingCondition',
    filter: false,
    isLocked: true,
    width: 30,
    children: [
      {
        key: 'travelDurationUnloaded',
        label: 'report.fields.travelDuration',
        header: 'travelDurationUnloaded',
        filter: false,
        isLocked: true,
        width: 20,
        childOfIndex: 3,
        isTopHead: 1,
        headerColspan: 1,
        tdAttr: (value, key, item, index) => {
          if (item.durationFilter.includes('unloadedTravelDuration')) {
            return { style: 'background-color: #FFF9E6;' }
          }
        },
      },
      {
        key: 'stoppedDurationUnloaded',
        label: 'report.fields.stoppedDuration',
        header: 'stoppedDurationUnloaded',
        filter: false,
        isLocked: true,
        width: 20,
        childOfIndex: 2,
        isTopHead: 0,
        headerColspan: 1,
        tdAttr: (value, key, item, index) => {
          if (item.durationFilter.includes('stoppedDurationUnloaded')) {
            return { style: 'background-color: #FFF9E6;' }
          }
        },
      },
      {
        key: 'averageSpeedUnloaded',
        label: 'report.fields.averageSpeed',
        header: 'averageSpeedUnloaded',
        filter: false,
        isLocked: true,
        width: 30,
        childOfIndex: 3,
        isTopHead: 0,
        headerColspan: 1,
      },
      {
        key: 'unloadedDuration',
        label: 'report.fields.unloadingDuration',
        header: 'unloadedDuration',
        filter: false,
        isLocked: true,
        width: 30,
        childOfIndex: 3,
        isTopHead: 0,
        headerColspan: 1,
        tdAttr: (value, key, item, index) => {
          if (item.durationFilter.includes('unloadingDuration')) {
            return { style: 'background-color: #FFF9E6;' }
          }
        },
      },
    ],
    headerColspan: 4,
  },
]

export default fields
